import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { useCallback } from 'react';
import { addMessageBox } from '../redux/actions/messageBoxesActions';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { DrawerButton } from './drawerButton';
export const LogOutDrawerButton = ({ closeDrawer }) => {
    const dispatch = useAppDispatch();
    const username = useAppSelector((state) => state.selfData.username);
    const onClick = useCallback(() => {
        closeDrawer();
        if (username) {
            dispatch(addMessageBox({
                type: 'confirm',
                title: `Log Out ${username}?`,
                isHtmlMessage: false,
                showCloseButton: true,
                buttons: [
                    {
                        label: 'Yes, Log Out',
                        actions: [{ type: 'refresh' }],
                        closeAfterClick: false
                    }
                ]
            }));
        }
    }, [dispatch, closeDrawer, username]);
    return _jsx(DrawerButton, { label: 'Log Out', startIcon: _jsx(LogoutRoundedIcon, {}), onClick: onClick, size: 'small' });
};
